angular.module('visitIstriaApp').controller('FooterController', FooterController);

FooterController.$inject = ['Services'];

function FooterController(Services) {
    var foot = this;

    foot.destinations = Services.destinations;
}